import { render, staticRenderFns } from "./NotificationsListScreen.vue?vue&type=template&id=7cd31bd8&scoped=true"
import script from "./NotificationsListScreen.vue?vue&type=script&lang=js"
export * from "./NotificationsListScreen.vue?vue&type=script&lang=js"
import style0 from "./NotificationsListScreen.vue?vue&type=style&index=0&id=7cd31bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd31bd8",
  null
  
)

export default component.exports